import { arrayOf, shape, string } from 'prop-types';

export const departmentType = shape({
  id: string.isRequired,
  name: string.isRequired,
  number: string.isRequired,
  accountId: string.isRequired,
  catalogTypes: arrayOf(string).isRequired,
  createTimestamp: string.isRequired
});

export const accountType = shape({
  id: string.isRequired,
  name: string.isRequired,
  number: string.isRequired,
  departments: arrayOf(departmentType).isRequired,
  createTimestamp: string.isRequired
});
